import * as React from 'react';

export const PerimetrIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M6 4l2-2 2 2v11H6zM11 4l2-2 2 2v11h-4zM1 4l2-2 2 2v11H1z" />
    </g>
  </svg>
);
